import { render, staticRenderFns } from "./Convogli.vue?vue&type=template&id=075f6d43&scoped=true&"
import script from "./Convogli.vue?vue&type=script&lang=js&"
export * from "./Convogli.vue?vue&type=script&lang=js&"
import style0 from "./Convogli.vue?vue&type=style&index=0&id=075f6d43&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "075f6d43",
  null
  
)

export default component.exports